<template>
  <ConfirmModal
    v-if="licence"
    class="confirm-licence-modal"
    :confirm-button-text="confirmText"
    :cancel="'cancel-btn'"
    @cancel="onClose"
    @confirm="onSave"
  >
    <div class="d-flex flex-column confirm-licence">
      <div class="d-flex mb-5 justify-content-center">
        <h2>
          {{ $t('_web_tournament_additional_settings_licence', 'Licence') }}
        </h2>
      </div>
      <TextSection
        v-if="licence.text"
        class="mb-3 description text-break custom-scrollbar"
        :description="licence.text"
      />
      <a
        v-if="licence.file"
        :href="licence.file"
        class="text-truncate tournament-info_description_licence mt-4 mb-4"
        target="_blank"
      >
        <Icon
          class="icon download-icon"
          name="download"
          :width="20"
          fill="rgba(157, 156, 247, 1)"
        />
        {{ $t('_web_tournaments_info_licence_pdf', 'Download PDF Licence') }}
      </a>
    </div>
  </ConfirmModal>
  <div v-else-if="!showCheckbox">
    <ConfirmModal
      class="confirm-licence-modal"
      :confirm-button-text="false"
      :cancel="'cancel-btn'"
      @cancel="closeModal"
    >
      <div class="d-flex flex-column confirm-licence">
        <div class="d-flex mb-5 justify-content-center">
          <h2>
            {{ $t('_web_tournament_additional_settings_licence', 'Licence') }}
          </h2>
        </div>
        <TextSection
          v-if="licence.text"
          class="mb-3 description text-break custom-scrollbar"
          :description="licence.text"
        />
        <a
          v-if="licence.file"
          :href="licence.file"
          class="text-truncate tournament-info_description_licence mt-4 mb-4"
          target="_blank"
        >
          <Icon
            class="icon download-icon"
            name="download"
            :width="20"
            fill="rgba(157, 156, 247, 1)"
          />
          {{ $t('_web_tournaments_info_licence_pdf', 'Download PDF Licence') }}
        </a>
      </div>
    </ConfirmModal>
  </div>
</template>

<script>
import ConfirmModal from '@/components/modal/children/HeraConfirm.vue';
import TextSection from '@/components/text/TextSection.vue';
import { mapActions } from 'vuex';
import Icon from '@/components/atoms/Icon';
import { prop } from '@/utils/factories';

export default {
  name: 'LicenceConfirmModal',
  components: {
    ConfirmModal,
    TextSection,
    Icon,
  },

  props: {
    licence: prop(Object),
    tournament: prop(Object),
    teamId: prop(String, ''),
    showCheckbox: prop(Boolean, { default: true, required: false }),
  },

  data() {
    return {
      agreed: false,
    };
  },
  computed: {
    confirmText() {
      return this.$t('_web_tournament-agree-confirm', 'Agree');
    },
    cancelText() {
      return this.$t('_web_stage_start_modal_confirmation_cancel', 'Cancel');
    },
  },
  methods: {
    ...mapActions([
      'closeModal',
      'errorNotify',
      'updateTournamentLicenceAccept',
    ]),
    onClose() {
      this.closeModal();
      this.$router.push({ path: '/' });
    },
    onSave() {
      // console.log('onSave');
      // console.log(this.tournament.id, this.$route.params.tournamentID);
      this.updateTournamentLicenceAccept({
        tournamentID:
          this.tournament.id !== null
            ? this.tournament.id
            : this.$route.params.tournamentID,
      }).then(() => {
        this.closeModal();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-licence {
  @include auto-rtl(text-align, left !important);
  margin-left: -1rem;
  margin-right: -1rem;

  .description.text-break {
    white-space: break-spaces;
    max-height: 40vh;
    overflow: auto;
  }

  a {
    color: rgba(157, 156, 247, 1);
  }

  div > h2 {
    text-transform: uppercase;
  }
}

.stages-modal-view {
  border: none;
  padding: 0;
}

.ubheader-text-modal {
  text-transform: uppercase !important;
}
</style>
